module.exports = __webpack_public_path__ + "img/2.279afb6d.png";